import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiDialog-paper': {
      width: '616px',
    },
  },
  actions: {
    padding: theme.spacing(1, 3, 2, 3),
  },
}));

export default useStyles;
